import React, { useState } from 'react';
import { Calendar, ArrowRight, TrendingUp, Search, SlidersHorizontal, ChevronDown } from 'lucide-react';
type TabType = 'All' | 'General' | 'Health' | 'Injury Management';
export function Blog() {
  const [activeTab, setActiveTab] = useState<TabType>('All');
  const [searchQuery, setSearchQuery] = useState('');
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const posts = [{
    id: 1,
    title: '10 Tips for Your First Marathon',
    category: 'Training',
    tab: 'General' as Exclude<TabType, 'All'>,
    date: 'Mar 10, 2024',
    author: 'RaceLookup',
    image: 'https://images.unsplash.com/photo-1513593771513-7b58b6c4af38?w=800&h=600&fit=crop&auto=format&q=80',
    excerpt: 'Preparing for 26.2 miles requires dedication, strategy, and the right nutrition plan.'
  }, {
    id: 2,
    title: 'Best Running Shoes of 2024',
    category: 'Gear',
    tab: 'General' as Exclude<TabType, 'All'>,
    date: 'Mar 05, 2024',
    author: 'RaceLookup',
    image: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&q=80',
    excerpt: 'We tested the top 50 running shoes to help you find the perfect pair for your stride.'
  }, {
    id: 3,
    title: 'Nutrition Guide for Runners',
    category: 'Health',
    tab: 'Health' as Exclude<TabType, 'All'>,
    date: 'Feb 28, 2024',
    author: 'RaceLookup',
    image: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?auto=format&fit=crop&q=80',
    excerpt: 'What to eat before, during, and after your run to maximize performance and recovery.'
  }, {
    id: 4,
    title: 'Top 5 Scenic Races in Europe',
    category: 'Travel',
    tab: 'General' as Exclude<TabType, 'All'>,
    date: 'Feb 20, 2024',
    author: 'RaceLookup',
    image: 'https://images.unsplash.com/photo-1476480862126-209bfaa8edc8?auto=format&fit=crop&q=80',
    excerpt: 'Discover breathtaking routes through historic cities and stunning landscapes.'
  }, {
    id: 5,
    title: 'Preventing Common Injuries',
    category: 'Health',
    tab: 'Injury Management' as Exclude<TabType, 'All'>,
    date: 'Feb 15, 2024',
    author: 'RaceLookup',
    image: 'https://images.unsplash.com/photo-1571008887538-b36bb32f4571?auto=format&fit=crop&q=80',
    excerpt: 'Learn how to stay injury-free with these essential strengthening exercises.'
  }, {
    id: 6,
    title: 'Mental Strategies for Race Day',
    category: 'Psychology',
    tab: 'General' as Exclude<TabType, 'All'>,
    date: 'Feb 10, 2024',
    author: 'RaceLookup',
    image: 'https://images.unsplash.com/photo-1551958219-acbc608c6377?w=800&h=600&fit=crop&auto=format&q=80',
    excerpt: 'Master your mindset to push through the wall and achieve your personal best.'
  }, {
    id: 7,
    title: 'Recovery Techniques for Athletes',
    category: 'Health',
    tab: 'Health' as Exclude<TabType, 'All'>,
    date: 'Feb 05, 2024',
    author: 'RaceLookup',
    image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&h=600&fit=crop&auto=format&q=80',
    excerpt: 'Optimize your recovery with proven techniques to reduce soreness and improve performance.'
  }, {
    id: 8,
    title: "Understanding Runner's Knee",
    category: 'Injury',
    tab: 'Injury Management' as Exclude<TabType, 'All'>,
    date: 'Jan 28, 2024',
    author: 'RaceLookup',
    image: 'https://images.unsplash.com/photo-1434682881908-b43d0467b798?w=800&h=600&fit=crop&auto=format&q=80',
    excerpt: 'Learn about the causes, prevention, and treatment of one of the most common running injuries.'
  }];
  const tabs: TabType[] = ['All', 'General', 'Health', 'Injury Management'];
  const filteredPosts = posts.filter(post => {
    const matchesTab = activeTab === 'All' || post.tab === activeTab;
    const matchesSearch = searchQuery === '' || post.title.toLowerCase().includes(searchQuery.toLowerCase()) || post.excerpt.toLowerCase().includes(searchQuery.toLowerCase()) || post.category.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesTab && matchesSearch;
  });
  const activeFiltersCount = (activeTab !== 'All' ? 1 : 0) + (searchQuery ? 1 : 0);
  return <div className="w-full bg-gray-50 min-h-screen pb-20" data-id="element-269">
      {/* Banner */}
      <div className="relative h-[300px] sm:h-[400px] overflow-hidden" data-id="element-270">
        <div className="absolute inset-0 bg-cover bg-center" style={{
        backgroundImage: 'url(https://images.unsplash.com/photo-1486218119243-13883505764c?w=1920&h=400&fit=crop&auto=format&q=80)'
      }} data-id="element-271">
          <div className="absolute inset-0 bg-gradient-to-r from-[#0E578E]/95 via-[#0E578E]/90 to-[#01AAE7]/85" data-id="element-272"></div>
        </div>

        <div className="absolute inset-0" data-id="element-273">
          <div className="absolute inset-0 opacity-5" style={{
          backgroundImage: `linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)`,
          backgroundSize: '50px 50px'
        }} data-id="element-274"></div>
        </div>

        <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 flex items-center justify-center" data-id="element-275">
          <div className="text-center max-w-3xl" data-id="element-276">
            <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-md text-white px-4 sm:px-5 py-2 sm:py-2.5 rounded-full text-xs sm:text-sm font-bold mb-4 sm:mb-6 border border-white/30 shadow-lg" data-id="element-277">
              <TrendingUp className="h-3.5 sm:h-4 w-3.5 sm:w-4" data-id="element-278" />
              {posts.length} Articles Available
            </div>

            <h1 className="text-4xl sm:text-5xl md:text-6xl font-black text-white mb-3 sm:mb-4 leading-tight drop-shadow-lg px-4" data-id="element-279">
              RaceLookup Blog
            </h1>

            <p className="text-base sm:text-lg md:text-xl text-white/95 leading-relaxed max-w-2xl mx-auto drop-shadow-md px-4" data-id="element-280">
              Expert advice, gear reviews, and inspiration for your running
              journey
            </p>
          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0" data-id="element-281">
          <svg viewBox="0 0 1440 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" data-id="element-282">
            <path d="M0 48H1440V24C1440 24 1200 0 720 0C240 0 0 24 0 24V48Z" fill="#F9FAFB" data-id="element-283" />
          </svg>
        </div>
      </div>

      {/* Search and Filter Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 mt-6 sm:mt-8" data-id="element-284">
        {/* Mobile: Filter Icon Button */}
        <div className="lg:hidden mb-6" data-id="element-285">
          <button onClick={() => setShowMobileFilters(!showMobileFilters)} className="relative w-full flex items-center justify-between gap-3 px-5 py-4 bg-white rounded-xl shadow-lg border-2 border-gray-200 hover:border-[#01AAE7] transition-all" data-id="element-286">
            <div className="flex items-center gap-3" data-id="element-287">
              <div className="w-10 h-10 bg-gradient-to-br from-[#0E578E] to-[#01AAE7] rounded-lg flex items-center justify-center" data-id="element-288">
                <SlidersHorizontal className="h-5 w-5 text-white" data-id="element-289" />
              </div>
              <div className="text-left" data-id="element-290">
                <div className="text-sm font-bold text-gray-900" data-id="element-291">
                  Filters & Search
                </div>
                <div className="text-xs text-gray-500" data-id="element-292">
                  {activeFiltersCount > 0 ? `${activeFiltersCount} active` : 'Tap to filter'}
                </div>
              </div>
            </div>
            <ChevronDown className={`h-5 w-5 text-gray-400 transition-transform ${showMobileFilters ? 'rotate-180' : ''}`} data-id="element-293" />
            {activeFiltersCount > 0 && <span className="absolute -top-2 -right-2 bg-[#01AAE7] text-white text-xs font-bold rounded-full h-6 w-6 flex items-center justify-center shadow-lg" data-id="element-294">
                {activeFiltersCount}
              </span>}
          </button>

          {/* Mobile Filter Dropdown */}
          {showMobileFilters && <div className="mt-4 bg-white rounded-xl shadow-xl border border-gray-200 p-5 space-y-4" data-id="element-295">
              {/* Search */}
              <div className="relative" data-id="element-296">
                <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400 z-10" data-id="element-297" />
                <input type="text" placeholder="Search articles..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-12 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:border-[#01AAE7] text-gray-900 transition-all" data-id="element-298" />
              </div>

              {/* Category Tabs */}
              <div data-id="element-299">
                <label className="block text-sm font-bold text-gray-700 mb-3" data-id="element-300">
                  Categories
                </label>
                <div className="grid grid-cols-2 gap-2" data-id="element-301">
                  {tabs.map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`px-4 py-3 rounded-xl text-sm font-semibold transition-all ${activeTab === tab ? 'bg-[#0E578E] text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-302">
                      {tab}
                    </button>)}
                </div>
              </div>

              {/* Apply Button */}
              <div className="flex gap-3 pt-3 border-t border-gray-200" data-id="element-303">
                {activeFiltersCount > 0 && <button onClick={() => {
              setSearchQuery('');
              setActiveTab('All');
            }} className="flex-1 px-4 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold rounded-xl transition-all" data-id="element-304">
                    Clear All
                  </button>}
                <button onClick={() => setShowMobileFilters(false)} className="flex-1 px-4 py-3 bg-gradient-to-r from-[#01AAE7] to-[#0199d6] text-white font-bold rounded-xl hover:from-[#0199d6] hover:to-[#0188c5] transition-all shadow-lg" data-id="element-305">
                  Apply Filters
                </button>
              </div>
            </div>}
        </div>

        {/* Desktop: Full Filter Bar */}
        <div className="hidden lg:block bg-white rounded-2xl shadow-xl border border-gray-100 p-5 mb-10" data-id="element-306">
          <div className="flex flex-col lg:flex-row gap-3 items-stretch lg:items-center mb-4" data-id="element-307">
            <div className="relative flex-1" data-id="element-308">
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400 z-10" data-id="element-309" />
              <input type="text" placeholder="Search articles..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-12 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:border-[#01AAE7] text-gray-900 transition-all" data-id="element-310" />
            </div>

            <div className="flex gap-2 lg:w-auto flex-wrap" data-id="element-311">
              {tabs.map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`px-4 py-3 rounded-xl text-sm font-semibold transition-all whitespace-nowrap ${activeTab === tab ? 'bg-[#0E578E] text-white hover:bg-[#0a4069]' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-312">
                  {tab}
                </button>)}
            </div>
          </div>

          <div className="flex items-center pt-4 border-t border-gray-100" data-id="element-313">
            <div className="flex items-center gap-2 text-sm text-gray-500 font-medium" data-id="element-314">
              <div className="w-2 h-2 bg-green-500 rounded-full" data-id="element-315"></div>
              <span data-id="element-316">
                Showing {filteredPosts.length} article
                {filteredPosts.length !== 1 ? 's' : ''}
                {activeTab !== 'All' && ` in ${activeTab}`}
              </span>
            </div>
          </div>
        </div>

        {/* Blog Posts Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8" data-id="element-317">
          {filteredPosts.length > 0 ? filteredPosts.map(post => <div key={post.id} className="group relative rounded-2xl overflow-hidden border-2 border-gray-100 hover:border-[#01AAE7] transition-all duration-300" style={{
          backgroundColor: '#FCFCFD'
        }} data-id="element-318">
                <div className="h-40 sm:h-48 relative overflow-hidden bg-gray-200" data-id="element-319">
                  <img src={post.image} alt={post.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700" data-id="element-320" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-321"></div>
                </div>

                <div className="p-5 sm:p-6" data-id="element-322">
                  <div className="flex items-center gap-2 mb-3 sm:mb-4" data-id="element-323">
                    <div className="flex items-center gap-1.5 sm:gap-2 bg-blue-50 text-[#01AAE7] px-2.5 sm:px-3 py-1 sm:py-1.5 rounded-lg" data-id="element-324">
                      <Calendar className="h-3.5 sm:h-4 w-3.5 sm:w-4" data-id="element-325" />
                      <span className="text-xs sm:text-sm font-bold" data-id="element-326">
                        {post.date}
                      </span>
                    </div>
                  </div>

                  <h3 className="text-lg sm:text-xl font-black text-gray-900 mb-2 sm:mb-3 group-hover:text-[#0E578E] transition-colors leading-tight" data-id="element-327">
                    {post.title}
                  </h3>

                  <p className="text-gray-600 text-xs sm:text-sm mb-4 sm:mb-6 line-clamp-2 leading-relaxed" data-id="element-328">
                    {post.excerpt}
                  </p>

                  <button className="w-full text-white bg-gradient-to-r from-[#01AAE7] to-[#0199d6] rounded-xl hover:from-[#0199d6] hover:to-[#0188c5] transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 py-3 sm:py-3.5 px-4 font-bold text-sm sm:text-base" data-id="element-329">
                    Read Article
                  </button>
                </div>
              </div>) : <div className="col-span-full text-center py-12 sm:py-16" data-id="element-330">
              <div className="text-gray-400 mb-4" data-id="element-331">
                <Search className="h-12 sm:h-16 w-12 sm:w-16 mx-auto mb-4" data-id="element-332" />
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2" data-id="element-333">
                No articles found
              </h3>
              <p className="text-sm sm:text-base text-gray-500 mb-4" data-id="element-334">
                Try adjusting your search or selecting a different category
              </p>
            </div>}
        </div>
      </div>
    </div>;
}